import { render, staticRenderFns } from "./DemandMatchDialog.vue?vue&type=template&id=5d202929&scoped=true"
import script from "./DemandMatchDialog.vue?vue&type=script&lang=js"
export * from "./DemandMatchDialog.vue?vue&type=script&lang=js"
import style0 from "./DemandMatchDialog.vue?vue&type=style&index=0&id=5d202929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d202929",
  null
  
)

export default component.exports